import React from "react";
import Toprate from "../api/Toprate";
import PaginatedMovieGrid from "./PaginatedMovieGrid";

const TopRateAll = () => (
  <PaginatedMovieGrid title="Top Rated Movies" fetcher={Toprate} />
);

export default TopRateAll;
